@if ((marker$ | async); as marker) {
  <div class="container">
    <div>
      {{marker.name}}
    </div>
    @if ((currentUser$ | async); as currentUser) {
      <div class="icons">
        @if (!marker.show) {
          <mat-icon>visibility_off</mat-icon>
        }
        @if (marker.isShared && currentUser.name == marker.author) {
          <mat-icon>person</mat-icon>
        }
        @if (marker.isShared) {
          <mat-icon>share</mat-icon>
        }
      </div>
    }
  </div>
}



